(function () {
  const roots = document.querySelectorAll('[data-or-tire-selector]');
  if (!roots.length) return;

  window.dataLayer = window.dataLayer || [];

  const normalKey = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  function flatten(value) {
    if (value === null || value === undefined || value === '') return [];
    if (Array.isArray(value)) return value.flatMap(flatten);
    if (typeof value === 'object') return flatten(value.value || value.name || value.title || '');

    const raw = String(value).trim();
    if (!raw) return [];

    if ((raw.startsWith('[') && raw.endsWith(']')) || (raw.startsWith('{') && raw.endsWith('}'))) {
      try {
        return flatten(JSON.parse(raw));
      } catch (error) {
        return [raw];
      }
    }

    return raw
      .split(/[,;|\n]+/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function dedupeLabels(values) {
    const labels = new Map();
    values.forEach((value) => {
      const label = String(value || '').trim().replace(/\s+/g, ' ');
      const key = normalKey(label);
      if (label && !labels.has(key)) labels.set(key, label);
    });
    return [...labels.values()].sort((a, b) => a.localeCompare(b, 'es', { numeric: true, sensitivity: 'base' }));
  }

  function readProducts(root) {
    const script = root.querySelector('[data-or-tire-products]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]')
        .map((product) => ({
          id: product.id,
          handle: product.handle,
          widths: dedupeLabels(flatten(product.width)),
          profiles: dedupeLabels(flatten(product.profile)),
          rims: dedupeLabels(flatten(product.rim)),
          patterns: dedupeLabels(flatten(product.pattern)),
        }))
        .filter(
          (product) =>
            product.handle && product.widths.length && product.profiles.length && product.rims.length && product.patterns.length
        );
    } catch (error) {
      console.warn('[or-tire-selector] Product data could not be parsed.', error);
      return [];
    }
  }

  function option(select, value, label) {
    const node = document.createElement('option');
    node.value = value;
    node.textContent = label;
    select.appendChild(node);
  }

  function resetSelect(select, disabled) {
    select.innerHTML = '';
    option(select, '', 'Seleccionar');
    select.disabled = disabled;
  }

  function hasValue(values, key) {
    return values.some((value) => normalKey(value) === key);
  }

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // Session persistence is optional.
    }
  }

  function storageRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      // Session persistence is optional.
    }
  }

  function push(event, params) {
    window.dataLayer.push({ event, ...params });
  }

  function init(root) {
    const products = readProducts(root);
    const widthSelect = root.querySelector('[data-or-tire-width]');
    const profileSelect = root.querySelector('[data-or-tire-profile]');
    const rimSelect = root.querySelector('[data-or-tire-rim]');
    const patternSelect = root.querySelector('[data-or-tire-pattern]');
    const applyButton = root.querySelector('[data-or-tire-apply]');
    const clearButton = root.querySelector('[data-or-tire-clear]');
    const result = root.querySelector('[data-or-tire-result]');
    const empty = root.querySelector('[data-or-tire-empty]');
    const actions = root.querySelector('[data-or-tire-actions]');
    const grid = document.querySelector('#product-grid');
    const items = [...document.querySelectorAll('[data-or-product-grid-item][data-or-product-handle]')];
    const collectionHandle = root.dataset.collectionHandle || '';
    const collectionTitle = root.dataset.collectionTitle || '';
    const storageKey = `orTireSelector:${collectionHandle}`;
    const openKey = `orTireSelectorOpen:${collectionHandle}:${window.location.pathname}`;

    if (
      !products.length ||
      !widthSelect ||
      !profileSelect ||
      !rimSelect ||
      !patternSelect ||
      !applyButton ||
      !grid
    ) {
      root.hidden = true;
      return;
    }

    const baseParams = () => ({
      collection_handle: collectionHandle,
      collection_title: collectionTitle,
    });

    const markOpen = () => {
      if (storageGet(openKey)) return;
      storageSet(openKey, '1');
      push('or_tire_selector_open', baseParams());
    };

    function selectedState() {
      return {
        widthKey: widthSelect.value,
        widthLabel: widthSelect.value ? widthSelect.selectedOptions[0]?.textContent || '' : '',
        profileKey: profileSelect.value,
        profileLabel: profileSelect.value ? profileSelect.selectedOptions[0]?.textContent || '' : '',
        rimKey: rimSelect.value,
        rimLabel: rimSelect.value ? rimSelect.selectedOptions[0]?.textContent || '' : '',
        patternKey: patternSelect.value,
        patternLabel: patternSelect.value ? patternSelect.selectedOptions[0]?.textContent || '' : '',
      };
    }

    function productsForWidth(widthKey) {
      return products.filter((product) => hasValue(product.widths, widthKey));
    }

    function productsForProfile(widthKey, profileKey) {
      return productsForWidth(widthKey).filter((product) => hasValue(product.profiles, profileKey));
    }

    function productsForRim(widthKey, profileKey, rimKey) {
      return productsForProfile(widthKey, profileKey).filter((product) => hasValue(product.rims, rimKey));
    }

    function updateProfiles() {
      const state = selectedState();
      resetSelect(profileSelect, true);
      resetSelect(rimSelect, true);
      resetSelect(patternSelect, true);
      applyButton.disabled = true;
      if (!state.widthKey) return;

      const profiles = dedupeLabels(productsForWidth(state.widthKey).flatMap((product) => product.profiles));
      profiles.forEach((profile) => option(profileSelect, normalKey(profile), profile));
      profileSelect.disabled = !profiles.length;
    }

    function updateRims() {
      const state = selectedState();
      resetSelect(rimSelect, true);
      resetSelect(patternSelect, true);
      applyButton.disabled = true;
      if (!state.widthKey || !state.profileKey) return;

      const rims = dedupeLabels(
        productsForProfile(state.widthKey, state.profileKey).flatMap((product) => product.rims)
      );
      rims.forEach((rim) => option(rimSelect, normalKey(rim), rim));
      rimSelect.disabled = !rims.length;
    }

    function updatePatterns() {
      const state = selectedState();
      resetSelect(patternSelect, true);
      applyButton.disabled = true;
      if (!state.widthKey || !state.profileKey || !state.rimKey) return;

      const patterns = dedupeLabels(
        productsForRim(state.widthKey, state.profileKey, state.rimKey).flatMap((product) => product.patterns)
      );
      patterns.forEach((pattern) => option(patternSelect, normalKey(pattern), pattern));
      patternSelect.disabled = !patterns.length;
    }

    function clearFilter(shouldPush) {
      const state = selectedState();
      items.forEach((item) => {
        item.hidden = false;
      });
      delete grid.dataset.orTireFilterActive;
      result.hidden = true;
      actions.hidden = true;
      empty.hidden = true;
      storageRemove(storageKey);

      if (shouldPush) {
        push('or_tire_filter_clear', {
          ...baseParams(),
          tire_width: state.widthLabel || undefined,
          tire_profile: state.profileLabel || undefined,
          tire_rim: state.rimLabel || undefined,
          tire_pattern: state.patternLabel || undefined,
        });
      }
    }

    function applyFilter(shouldPush) {
      const state = selectedState();
      if (!state.widthKey || !state.profileKey || !state.rimKey || !state.patternKey) return;

      const matches = productsForRim(state.widthKey, state.profileKey, state.rimKey).filter((product) =>
        hasValue(product.patterns, state.patternKey)
      );
      const handles = new Set(matches.map((product) => product.handle));

      items.forEach((item) => {
        item.hidden = !handles.has(item.dataset.orProductHandle);
      });

      const measure = `${state.widthLabel}/${state.profileLabel} R${state.rimLabel}`;
      result.textContent = `${matches.length} ${matches.length === 1 ? 'neumático disponible' : 'neumáticos disponibles'} en ${measure} · ${state.patternLabel}`;
      result.hidden = false;
      actions.hidden = false;
      empty.hidden = matches.length !== 0;
      grid.dataset.orTireFilterActive = 'true';
      storageSet(
        storageKey,
        JSON.stringify({
          widthKey: state.widthKey,
          profileKey: state.profileKey,
          rimKey: state.rimKey,
          patternKey: state.patternKey,
        })
      );

      if (shouldPush) {
        push('or_tire_filter_apply', {
          ...baseParams(),
          tire_width: state.widthLabel,
          tire_profile: state.profileLabel,
          tire_rim: state.rimLabel,
          tire_pattern: state.patternLabel,
          matching_product_count: matches.length,
        });
      }
    }

    dedupeLabels(products.flatMap((product) => product.widths)).forEach((width) =>
      option(widthSelect, normalKey(width), width)
    );

    root.addEventListener('pointerdown', markOpen, { once: true });
    root.addEventListener('focusin', markOpen, { once: true });

    widthSelect.addEventListener('change', () => {
      markOpen();
      clearFilter(false);
      updateProfiles();
      const state = selectedState();
      if (state.widthKey) push('or_tire_width_select', { ...baseParams(), tire_width: state.widthLabel });
    });

    profileSelect.addEventListener('change', () => {
      clearFilter(false);
      updateRims();
      const state = selectedState();
      if (state.profileKey) {
        push('or_tire_profile_select', {
          ...baseParams(),
          tire_width: state.widthLabel,
          tire_profile: state.profileLabel,
        });
      }
    });

    rimSelect.addEventListener('change', () => {
      clearFilter(false);
      updatePatterns();
      const state = selectedState();
      if (state.rimKey) {
        push('or_tire_rim_select', {
          ...baseParams(),
          tire_width: state.widthLabel,
          tire_profile: state.profileLabel,
          tire_rim: state.rimLabel,
        });
      }
    });

    patternSelect.addEventListener('change', () => {
      clearFilter(false);
      const state = selectedState();
      applyButton.disabled = !state.patternKey;
      if (state.patternKey) {
        push('or_tire_pattern_select', {
          ...baseParams(),
          tire_width: state.widthLabel,
          tire_profile: state.profileLabel,
          tire_rim: state.rimLabel,
          tire_pattern: state.patternLabel,
        });
      }
    });

    applyButton.addEventListener('click', () => applyFilter(true));

    clearButton?.addEventListener('click', () => {
      clearFilter(true);
      widthSelect.value = '';
      updateProfiles();
    });

    try {
      const saved = JSON.parse(storageGet(storageKey) || 'null');
      if (saved?.widthKey) {
        widthSelect.value = saved.widthKey;
        updateProfiles();
        profileSelect.value = saved.profileKey || '';
        updateRims();
        rimSelect.value = saved.rimKey || '';
        updatePatterns();
        patternSelect.value = saved.patternKey || '';
        applyButton.disabled = !patternSelect.value;
        if (patternSelect.value) applyFilter(false);
      }
    } catch (error) {
      storageRemove(storageKey);
    }
  }

  roots.forEach(init);
})();
